import { render, staticRenderFns } from "./m-gc-step-underlay.vue?vue&type=template&id=28f4a398&scoped=true&"
import script from "./m-gc-step-underlay.vue?vue&type=script&lang=js&"
export * from "./m-gc-step-underlay.vue?vue&type=script&lang=js&"
import style0 from "./m-gc-step-underlay.vue?vue&type=style&index=0&id=28f4a398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4a398",
  null
  
)

export default component.exports